import { Omit, Partial } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { FeeDefinition } from './fee-definition.entity';

export class UpdateFeeDefinitionDto extends Partial(Omit(FeeDefinition, [...BaseEntityFieldsArray, 'buyerFee', 'supplierFee'])) {}
